import { Separator } from '@ais-ui/ui-core';

import { useLocalization } from '@ais-ui/locale-management';
import { GeneralForm } from './GeneralForm';

export function SettingsGeneralPage() {
  const { messages } = useLocalization();

  return (
    <div className="space-y-6 w-full">
      <div>
        <h3 className="text-2xl font-medium">
          {messages.settingsGeneralTitle}
        </h3>
        <p className="text-sm text-muted-foreground">
          {messages.settingsGeneralSubtitle}
        </p>
      </div>
      <Separator className="w-full" />
      <GeneralForm />
    </div>
  );
}
